import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { Provider } from 'jotai'
import { parse } from 'valibot'

import { ContainerLayout, ContentLayout } from '@/components/layouts'
import { authStore } from '@/features/auth/atoms/'

import { publicSearchSchema } from './-models'

export const Route = createFileRoute('/_public')({
  component: PublicRouteLayout,
  validateSearch: (search) => parse(publicSearchSchema, search),
  beforeLoad: ({ context, search }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({
        to: search.redirect || '/'
      })
    }
  }
})

function PublicRouteLayout() {
  return (
    <ContainerLayout data-testid="public-route-layout">
      <ContentLayout>
        <Provider store={authStore}>
          <Outlet />
        </Provider>
      </ContentLayout>
    </ContainerLayout>
  )
}
